import { useRef } from "react";

// Collapse overlapping calls into a single in-flight promise until that async
// work settles.
export function useSingleFlight<TReturn, TArgs extends unknown[]>(
  wrappedFn: (...args: TArgs) => Promise<TReturn>
) {
  const inFlightRef = useRef<Promise<TReturn>>();

  return async function singleFlightGuard(...args: TArgs): Promise<TReturn> {
    if (inFlightRef.current) {
      return inFlightRef.current;
    }

    const promise = wrappedFn(...args).finally(() => {
      if (inFlightRef.current === promise) {
        inFlightRef.current = undefined;
      }
    });

    inFlightRef.current = promise;
    return promise;
  };
}
